import { ReconditioningOptions } from "@slfinrtl/ui-bff-routes"
import { defineMessages, useIntl } from "react-intl"
import type { RadioOption } from "src/components/form/radio/radioGroup/RadioGroup"

const messages = defineMessages({
	noSelection: {
		defaultMessage: "No selection",
		id: "conditionAndHistory.reconditioning.noselection",
	},
	notReconditioned: {
		defaultMessage: "Not reconditioned",
		id: "conditionAndHistory.reconditioning.notReconditioned",
	},
	reconditioned: {
		defaultMessage: "Reconditioned",
		id: "conditionAndHistory.reconditioning.reconditioned",
	},
})

export const useReconditioningOptions = (): RadioOption[] => {
	const { formatMessage } = useIntl()
	return [
		{
			label: formatMessage(messages.noSelection),
			value: ReconditioningOptions.NO_SELECTION,
		},
		{
			label: formatMessage(messages.reconditioned),
			value: ReconditioningOptions.RECONDITIONED,
		},
		{
			label: formatMessage(messages.notReconditioned),
			value: ReconditioningOptions.NOT_RECONDITIONED,
		},
	]
}
